import {
  ResourceService,
} from '@/internal';

export default class TemplateService extends ResourceService {
  constructor() {
    super();
    this.baseUrl = 'template';
  }

  duplicate(id, payload = {}) {
    const {params, responseType} = payload;

    return this.request({
      method: 'post',
      url: this.generateUrl(`${this.baseUrl}/${id}/duplicate`, params),
      params: this.prepareParams(params),
      responseType,
    });
  }
}
